import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Cookies } from "react-cookie-consent";

export interface CookieConsent {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

interface CookieConsentStore {
  consent: CookieConsent | null;
  updateConsent: (consent: CookieConsent) => void;
  hasConsented: (type: keyof CookieConsent) => boolean;
  isInEmbeddedContext: () => boolean;
}

export const useCookieConsent = create<CookieConsentStore>()(
  persist(
    (set, get) => ({
      consent: null,
      
      updateConsent: (consent: CookieConsent) => {
        set({ consent });
        
        // Set cookies based on consent
        if (consent.necessary) {
          Cookies.set('cookie-consent-necessary', '1', { expires: 365 });
        } else {
          Cookies.remove('cookie-consent-necessary');
        }
        
        if (consent.analytics) {
          Cookies.set('cookie-consent-analytics', '1', { expires: 365 });
        } else {
          Cookies.remove('cookie-consent-analytics');
        }
        
        if (consent.marketing) {
          Cookies.set('cookie-consent-marketing', '1', { expires: 365 });
        } else {
          Cookies.remove('cookie-consent-marketing');
        }
      },
      
      hasConsented: (type: keyof CookieConsent) => {
        const { consent } = get();
        if (!consent) return false;
        return consent[type];
      },
      
      isInEmbeddedContext: () => {
        // Vérifier si nous sommes dans une iframe
        const isInIframe = window.self !== window.top;
        // Vérifier si le paramètre URL 'embedded' est présent
        const isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';
        // Vérifier si nous sommes sur la route du widget
        const isWidget = window.location.pathname.includes('/widget');
        
        return isInIframe || isEmbedded || isWidget;
      }
    }),
    {
      name: 'cookie-consent-storage'
    }
  )
);